// src/redux/auth/thunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../../utils/auth";
import { handleApiError } from "../../handleApiError";
const API_URL = process.env.REACT_APP_API_URL;

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      // console.log(credentials);
      const response = await axios.post(API_URL + "/auth/signin", credentials);
      // console.log("Full Response:", response?.data);

      const data = response?.data.data || response.data;

      const authUser = {
        status: "success",
        data: {
          email: data.user?.email || data.email,
          username: data.user?.fullName || data.username,
          token: data.token?.startsWith("Bearer")
            ? data.token
            : `Bearer ${data.token}`,
        },
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));

      return authUser;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL + "/auth/signup", userData);
      const data = response.data.data || response.data;

      const authUser = {
        status: "success",
        data: {
          email: data.user?.email || data.email,
          username: data.user?.fullName || `${data.firstName} ${data.lastName}`,
          token: data.token?.startsWith("Bearer")
            ? data.token
            : `Bearer ${data.token}`,
        },
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));

      return authUser;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error?.response?.data?.error.message);
    }
  },
);

export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async (googleData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/google`, googleData);
      const data = response.data.data || response.data;

      const authUser = {
        status: "success",
        data: {
          email: data.user?.email || data.email,
          username: data.user?.fullName || data.username,
          token: data.token?.startsWith("Bearer")
            ? data.token
            : `Bearer ${data.token}`,
        },
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));
      return authUser;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error?.response?.data?.message || "Google login failed",
      );
    }
  },
);

export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async (emailData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/auth/forgetPassword`,
        emailData,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error?.response?.data?.message || "Forget Password failed",
      );
    }
  },
);

export const verifyOTP = createAsyncThunk(
  "auth/verifyOTP",
  async (otpData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/auth/signup/configurationOTP`,
        otpData,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error?.response?.data?.message || "OTP verification failed",
      );
    }
  },
);

export const resendOTP = createAsyncThunk(
  "auth/resendOTP",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/resendOTP`, {
        email,
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to resend OTP",
      );
    }
  },
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ token, passwordData }, { rejectWithValue }) => {
    try {
      // console.log(token);
      // console.log(passwordData);
      const response = await axios.post(
        `${API_URL}/auth/resetPassword`,
        passwordData,
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      );
      // console.log(response);
      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error?.response?.data?.message || "Password reset failed",
      );
    }
  },
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (passwordData, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_URL}/auth/changePassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(passwordData),
      });

      const data = await response.json().catch(() => null);

      const authUser = {
        status: "success",
        data: {
          token: data?.data?.token?.startsWith("Bearer")
            ? data?.data?.token
            : `Bearer ${data?.data?.token}`,
        },
      };

      localStorage.setItem("authUser", JSON.stringify(authUser));

      if (!response.ok) {
        // console.log(data.error);
        return rejectWithValue(data || "Change Password failed");
      }

      return data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.message);
    }
  },
);

export const AddPhoneNumber = createAsyncThunk(
  "userAddress/AddPhoneNumber",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      if (!token) throw new Error("No token found");
      const tokenWithoutBearer = token.replace("Bearer ", "");
      // console.log("Token in thunk:", tokenWithoutBearer);
      // console.log("payload in thunk:", payload);
      const response = await axios.post(`${API_URL}/user/addPhone`, payload, {
        headers: { token: tokenWithoutBearer },
      });

      return response.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(
        error.response?.data || "Failed to create address",
      );
    }
  },
);
